import { Component, Input, OnInit } from '@angular/core';
import { RootScopeService } from '../../../services/root-scope.service';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit {

  iconConfig: any;
  alertConfig: any;
  @Input()
  isWarningToHide: boolean = true;

  @Input()
  isErrorToHide: boolean = true;

  @Input()
  isInfoToHide: boolean = true;

  @Input()
  isSuccessToHide: boolean = true;


  @Input()
  msg: any;


  constructor(public rootScope: RootScopeService) {

    this.iconConfig = {
      iconName: 'bullhorn',
      iconType: 'fal'
    }

    this.alertConfig = {
      type: 'error'
    }
  }

  ngOnInit(): void {
  }

  closeWarning() {
    // console.log("Method closeWarning called ")
    this.rootScope.isWarningToHide = !this.rootScope.isWarningToHide;
  }

}
